import { useMemo } from 'react';
import { getExpectedServiceDateAndTimeSlot } from '../helpers/order';
import { Order } from '../models';

export const useServiceDate = (order: Order) => {
  const serviceDate = useMemo(() => {
    const range = getExpectedServiceDateAndTimeSlot(order);
    if (range) {
      return range.from;
    } else {
      return null;
    }
  }, [order]);

  return serviceDate;
};
